import { Controller } from '@hotwired/stimulus'

const openClass = 'dropdown-menu__open'

export default class extends Controller {
  static targets = ['menu']

  initialize() {
    document.addEventListener('click', ({ target }) => {
      if (!this.element.contains(target)) {
        this.close()
      }
    })
  }

  open() {
    this.menuTarget.classList.toggle('active')
    this.menuTarget.classList.toggle(openClass)
  }

  close() {
    this.menuTarget.classList.remove('active')
    this.menuTarget.classList.remove(openClass)
  }
}
